import { useState, useCallback } from 'react'

export default function useIsFocused(initialFocused = false) {
  const [isFocused, setFocused] = useState(initialFocused)
  const onFocus = useCallback(() => setFocused(true), [])
  const onBlur = useCallback(() => setFocused(false), [])

  return [isFocused, { onFocus, onBlur }] as const
}
